var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FsHeading_internals;
import 'element-internals-polyfill';
import typographyHostStyles from '@cof/fs-typography-core/lib/typography.host.lit.min.js';
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
/**
 * The web component implementation of the Financial Services heading component
 *
 * ## Installation
 *
 * ```bash
 * npm i @cof/fs-typography-wc
 * ```
 *
 * ## Usage
 *
 * To import the side-effectful registration of `<fs-heading>` call
 *
 * ```javascript
 * import '@cof/fs-typography-wc/fs-heading.js';
 * ```
 *
 * To import the `FsHeading` class as either a base class or to self-register the custom element use
 *
 * ```javascript
 * import { FsHeading } from '@cof/fs-typography-wc';
 * ```
 *
 * ## Example
 *
 * ```html
 * <fs-heading level="1" size="large">Hello world</fs-heading>
 * ```
 *
 * @element fs-heading
 * @slot - The heading text
 */
export class FsHeading extends LitElement {
    constructor() {
        super();
        /** Contains APIs for working with the accessibility object model */
        _FsHeading_internals.set(this, this.attachInternals());
        /**
         * The relative heading level this element represents
         * @attribute level
         */
        this.level = 1;
        /**
         * Adjust the size and styles of the heading element within the context
         * of the FS Design System
         * @attribute size
         */
        this.size = 'medium';
        /**
         * The heading component's priority or display value
         * @attribute variant
         */
        this.variant = 'primary';
        /** Make sure this element will have a default role */
        __classPrivateFieldGet(this, _FsHeading_internals, "f").role = 'heading';
    }
    /** When the level changes, update the internals aria-level */
    updated(changed) {
        if (changed.has('level')) {
            __classPrivateFieldGet(this, _FsHeading_internals, "f").ariaLevel = this.level.toString();
        }
    }
    render() {
        return html `<slot></slot>`;
    }
}
_FsHeading_internals = new WeakMap();
FsHeading.styles = [typographyHostStyles];
/** Set the elemnent's canonical name */
FsHeading.canonicalName = 'heading';
__decorate([
    property({ type: Number, reflect: true })
], FsHeading.prototype, "level", void 0);
__decorate([
    property()
], FsHeading.prototype, "size", void 0);
__decorate([
    property()
], FsHeading.prototype, "variant", void 0);
//# sourceMappingURL=Heading.js.map